// Other NPM packages
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { A11yModule } from '@angular/cdk/a11y';

// PrimeNG
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { DatePickerModule } from 'primeng/datepicker';

import { ClickOutsideModule } from 'ng-click-outside';

// Common
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { CommonFormsModule } from '../Forms/forms.module';
import { MiscModule } from '../Misc/misc.module';
import { TagsModule } from '../../Common/Tags/tags.module';
import { TakeOverModule } from '../TakeOver/take-over.module';

// This module
import { LayoutModule } from '../Layout/layout.module';
import { FilterModule } from '../Filter/filter.module';
import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';
import { CommonBasicModule } from '../Basic/basic.module';
import { TargetingSharedModule } from '../TargetingShared/targeting-shared.module';

import { FileDownloadsApi } from '@api/fileDownloads/file-downloads.api';

import { TVEyesMentionsService } from './services/tveyes-mentions.service';
import { TranslateMentionsService } from './services/translate-mentions.service';
import { MentionInsightsExplorerService } from './services/mention-insights-explorer.service';

import { FilterStringByIndexPipe } from './pipes/FilterStringByIndex/filter-string-by-index.pipe';

import { MentionDetailsTakeOverPanelComponent } from './components/MentionDetailsTakeOverPanel/mention-details-take-over-panel.component';
import { MentionDetailsComponent } from './components/MentionDetails/mention-details.component';
import { MentionListComponent } from './components/MentionList/mention-list.component';
import { MentionCardComponent } from './components/MentionCard/mention-card.component';
import { MentionWorkbenchDialogComponent } from './components/MentionWorkbenchDialog/mention-workbench-dialog.component';
import { MentionLanguageDisplayComponent } from './components/MentionLanguageDisplay/mention-language-display.component';
import { MentionTranslationTabsComponent } from './components/MentionTranslationTabs/mention-translation-tabs.component';
import { MentionSetPreferredComponent } from './components/MentionSetPreferred/mention-set-preferred.component';
import { MentionInsightUpsellCardComponent } from './components/MentionInsightUpsellCard/mention-insight-upsell-card.component';
import { MentionInsightsExplorerTabComponent } from './components/MentionInsightsExplorerTab/mention-insights-explorer-tab.component';
import { MieInteractiveListComponent } from './components/MieInteractiveList/mie-interactive-list.component';
import { UnsavedExportInfoMessageComponent } from './components/UnsavedExportInfoMessage/unsaved-export-info-message.component';
import { FinancialTimesAttributionComponent } from './components/FinancialTimesAttribution/financial-times-attribution.component';
import { ManageMentionOrganizationDialogComponent } from './components/ManageMentionOrganization/manage-mention-organization-dialog.component';
import { CoverageInsightMentionCardComponent } from './components/CoverageInsightMentionCard/coverage-insight-mention-card.component';
import { MentionContentComponent } from './components/MentionContent/mention-content.component';
import { MentionInformationComponent } from './components/MentionInformation/mention-information.component';
import { FoldersPickerComponent } from './components/FoldersPicker/folders-picker.component';
import { MentionViewTveyesPanelComponent } from './components/MentionViewTvEyesPanel/mention-view-tveyes-panel.component';

const DECLARATIONS_EXPORTS = [
    FilterStringByIndexPipe,
    MentionDetailsTakeOverPanelComponent,
    MentionDetailsComponent,
    MentionListComponent,
    MentionCardComponent,
    MentionWorkbenchDialogComponent,
    MentionLanguageDisplayComponent,
    MentionTranslationTabsComponent,
    MentionSetPreferredComponent,
    MentionInsightUpsellCardComponent,
    MentionInsightsExplorerTabComponent,
    ManageMentionOrganizationDialogComponent,
    MieInteractiveListComponent,
    UnsavedExportInfoMessageComponent,
    FinancialTimesAttributionComponent,
    CoverageInsightMentionCardComponent,
    MentionContentComponent,
    MentionInformationComponent,
    FoldersPickerComponent,
    MentionViewTveyesPanelComponent
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SelectModule,
        TooltipModule,
        LocalizationModule,
        AutoCompleteModule,
        CommonFormsModule,
        MiscModule,
        InputTextModule,
        LayoutModule,
        FilterModule,
        CoreDialogsModule,
        CommonBasicModule,
        RouterModule,
        DatePickerModule,
        TargetingSharedModule,
        ClickOutsideModule,
        TagsModule,
        A11yModule,
        TakeOverModule,
        ReactiveFormsModule
    ],
    declarations: [
        ...DECLARATIONS_EXPORTS
    ],
    exports: [
        ...DECLARATIONS_EXPORTS
    ],
    providers: [
        TVEyesMentionsService,
        TranslateMentionsService,
        MentionInsightsExplorerService,
        FileDownloadsApi
    ]
})
export class MentionsModule { }
